import { ShieldCheck } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AgentAvatar } from '@/components/AgentAvatar';
import type { AgentsResponse } from '@/lib/collections/agents';
import { formatCount, formatSol } from '@/utils/format';

interface AgentCardProps {
  agent: AgentsResponse;
  className?: string;
}

export const AgentCard: React.FC<AgentCardProps> = ({ agent, className = '' }) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(`/agents/${agent.id}`)}
      className={`group text-left w-full rounded-2xl bg-card border border-border p-4 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-primary/60 ${className}`}
    >
      <div className="flex items-start gap-3">
        <AgentAvatar avatarUrl={agent.avatarUrl} avatarGradient={agent.avatarGradient} name={agent.name} size="md" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5">
            <h3 className="font-bold text-foreground truncate transition-colors duration-300 group-hover:text-primary">
              {agent.name}
            </h3>
            {agent.isFunctional && <ShieldCheck className="w-4 h-4 text-primary shrink-0" />}
          </div>
          <p className="text-sm text-muted-foreground line-clamp-1 mt-0.5">{agent.description}</p>
        </div>
      </div>

      <div className="mt-3 flex items-center justify-between">
        <span
          className={`text-xs font-semibold px-2.5 py-1 rounded-full transition-colors duration-300 ${
            agent.statsRuns > 0
              ? 'bg-accent text-accent-foreground group-hover:bg-primary group-hover:text-primary-foreground'
              : 'bg-secondary text-secondary-foreground'
          }`}
        >
          {agent.statsRuns > 0 ? `${formatCount(agent.statsRuns)} runs` : 'Available'}
        </span>
        <span className="text-xs font-bold text-primary">{formatSol(agent.pricePerCall)}</span>
      </div>
    </button>
  );
};

export default AgentCard;
